/**
 * Safety net for stale JS chunks that do not go through Vite's preloadError
 * (e.g. Safari + Vue AsyncComponentWrapper → TypeError "Importing a module script failed").
 *
 * Nuxt's built-in handler (experimental.emitRouteChunkError: 'automatic-immediate')
 * already covers vite:preloadError → app:chunkError → reloadNuxtApp.
 */

const STALE_CHUNK_PATTERN
  = /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk [\da-z]+ failed|error loading dynamically imported module/i

let reloading = false

function errorMessage(error) {
  if (typeof error === 'string') {
    return error
  }

  return error?.message ?? error?.reason?.message ?? String(error ?? '')
}

function isStaleChunkError(error) {
  return STALE_CHUNK_PATTERN.test(errorMessage(error))
}

function reloadForNewBuild() {
  if (reloading) {
    return
  }

  reloading = true
  reloadNuxtApp({ persistState: true })
}

export default defineNuxtPlugin({
  name: 'stale-chunk-reload',
  enforce: 'pre',
  setup(nuxtApp) {
    nuxtApp.hook('app:error', (error) => {
      if (isStaleChunkError(error)) {
        reloadForNewBuild()
      }
    })

    nuxtApp.hook('vue:error', (error) => {
      if (isStaleChunkError(error)) {
        reloadForNewBuild()
      }
    })

    window.addEventListener('unhandledrejection', (event) => {
      if (!isStaleChunkError(event.reason)) {
        return
      }

      event.preventDefault()
      reloadForNewBuild()
    })
  },
})
